module.exports = __webpack_public_path__ + "img/__icon_BUS_SKRZYNIA.4a6cf610.svg";